// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Styles */
.MileageAnalysisTab_bus_analysis_header__Wx4n0 {
  color: #364e69;
}

.MileageAnalysisTab_bus_selected_header__3w-B- {
  color: #364e69;
}

/* Download Button */
.MileageAnalysisTab_bus_download_button__ASssO {
  color: #83a4cf;
  background-color: transparent;
  border: none;
}

/* Tabs Container */
.MileageAnalysisTab_bus_tabs_container__vI1ID {
  background-color: #e9ecef;
}

.MileageAnalysisTab_bus_tabs_wrapper__z5147 {
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.MileageAnalysisTab_bus_tabs_wrapper__z5147::-webkit-scrollbar {
  display: none;
}

/* Tab Item */
.MileageAnalysisTab_bus_tab_item__\\+ykSg {
  cursor: pointer;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: all 0.2s ease;
  font-size: 14px;
  padding-bottom: 8px;
}

.MileageAnalysisTab_bus_tab_item_active__bUMHb {
  color: #358696;
  border-bottom: 2px solid #358696;
}

.MileageAnalysisTab_bus_tab_item_inactive__\\+p8y2 {
  color: #6c757d;
}

/* Progress Bar */
.MileageAnalysisTab_bus_progress_container__i1JeK {
  height: 8px;
  background-color: #ced4da;
}

.MileageAnalysisTab_bus_progress_bar__F5HH- {
  background-color: #6c757d;
  transition: width 0.3s ease;
}

/* Benchmark Tabs */
.MileageAnalysisTab_bus_benchmark_tab__45lfm {
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.MileageAnalysisTab_bus_benchmark_tab_active__8lKW- {
  color: #358696;
  border-bottom: 2px solid #358696;
}

.MileageAnalysisTab_bus_benchmark_tab_inactive__4UTIH {
  color: #6c757d;
}

/* Chart Icon */
.MileageAnalysisTab_bus_chart_icon__3CSV1 {
  color: #364e69;
}

/* Filter Summary */
.MileageAnalysisTab_bus_filter_summary__Pm8zC {
  color: #6c757d;
}

/* Section Container */
.MileageAnalysisTab_bus_section_container__iy8Tq {
  background-color: white;
  border: 1px solid #e9ecef;
  min-height: 300px;
  scroll-margin-top: 20px;
}

/* Section Header */
.MileageAnalysisTab_bus_section_header__ltXgW {
  padding-bottom: 8px;
  transition: all 0.2s ease;
}

.MileageAnalysisTab_bus_section_header_active__-qe98 {
  color: #83a4cf;
  border-bottom: 2px solid #83a4cf;
}

.MileageAnalysisTab_bus_section_header_inactive__8-RNc {
  color: #364e69;
  border-bottom: 2px solid #e9ecef;
}

/* Special Sections */
.MileageAnalysisTab_bus_mileage_insights_container__qFA6C {
  background-color: white;
  border: 1px solid #e9ecef;
  scroll-margin-top: 20px;
}

.MileageAnalysisTab_bus_waterfall_chart_container__uIMY9 {
  background-color: white;
  border: 1px solid #e9ecef;
  scroll-margin-top: 20px;
}

/* Content Placeholder */
.MileageAnalysisTab_bus_content_placeholder__yVg8d {
  color: #6c757d;
}

/* Vehicle Container */
.MileageAnalysisTab_bus_vehicleContainer__U3THW {
  height: 120px;
  gap: 15px;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
}

/* Vehicle Details Section */
.MileageAnalysisTab_bus_vehicleDetailsSection__BYBBt {
  background-color: white;
  border-radius: 4px;
  height: 100%;
  min-width: 150px;
}

.MileageAnalysisTab_bus_vehicleDetailsTitle__Y9lX\\+ {
  color: #364e69;
  font-weight: 600;
  font-size: 14px;
}

/* Add Vehicle Slot Styles */
.MileageAnalysisTab_bus_addVehicleSlot__txTu7 {
  background-color: #77c4d3;
  border-radius: 4px;
  height: 100%;
  min-width: 150px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.MileageAnalysisTab_bus_addVehicleSlot__txTu7:hover {
  background-color: #85ccdb;
}

/* Selected Vehicle Slot */
.MileageAnalysisTab_bus_selectedVehicleSlot__tnGSl {
  background-color: #f8f9fa;
  border-radius: 4px;
  height: 100%;
  min-width: 150px;
  cursor: pointer;
}

/* Add Vehicle Content */
.MileageAnalysisTab_bus_addVehicleContent__Fp9Hi {
  color: #364e69;
  font-size: 14px;
  font-weight: 600;
}

.MileageAnalysisTab_bus_addVehicleIcon__aV3HP {
  width: 20px;
  height: 20px;
  background-color: #358696;
  border-radius: 50%;
}

/* Selected Vehicle Text */
.MileageAnalysisTab_bus_selectedVehicleText__0LSY7 {
  font-size: 12px;
  color: #364e69;
  font-weight: 600;
  text-align: center;
  word-break: break-word;
}

/* Best Day Section */
.MileageAnalysisTab_bus_bestDaySection__PQ1hL {
  background-color: #f8f9fa;
  border-radius: 4px;
  height: 100%;
}

.MileageAnalysisTab_bus_bestDayText__UuxLv {
  font-style: italic;
  font-size: 12px;
}

/* Selected Vehicle Display */
.MileageAnalysisTab_bus_selectedVehicleDisplay__Z8IE8 {
  background-color: rgba(66, 133, 244, 0.1);
}

.MileageAnalysisTab_bus_selectedVehicleLabel__JYXhs {
  font-size: 12px;
  color: #333;
}

.MileageAnalysisTab_bus_clearButton__Q75EL {
  background-color: transparent;
  border: none;
}

/* Modal Styles */
.MileageAnalysisTab_bus_modalOverlay__QKlQn {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.MileageAnalysisTab_bus_modalContainer__9oGQz {
  width: 500px;
  max-height: 600px;
  overflow: hidden;
}

.MileageAnalysisTab_bus_modalTitle__GbFkw {
  color: #364e69;
  font-weight: 600;
}

.MileageAnalysisTab_bus_closeButton__zpjTr {
  background-color: transparent;
  border: none;
}

/* Search Input */
.MileageAnalysisTab_bus_searchIcon__1Eg\\+E {
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.MileageAnalysisTab_bus_searchInput__1aeru {
  padding-left: 40px;
  font-size: 14px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

/* Vehicle List */
.MileageAnalysisTab_bus_vehicleList__fVRsV {
  max-height: 400px;
  overflow-y: auto;
  min-height: 300px;
}

/* Empty State */
.MileageAnalysisTab_bus_emptyStateTitle__SG-0s {
  font-size: 16px;
}

.MileageAnalysisTab_bus_emptyStateSubtitle__eoF3O {
  font-size: 14px;
}

/* Vehicle Item Styles */
.MileageAnalysisTab_bus_vehicleItem__10j44 {
  cursor: pointer;
  transition: all 0.2s;
  border-width: 1px;
}

.MileageAnalysisTab_bus_vehicleItem__10j44:hover {
  background-color: #f8f9fa;
}

.MileageAnalysisTab_bus_vehicleItemSelected__9\\+R6C {
  border-width: 2px;
}

.MileageAnalysisTab_bus_vehicleName__-kvbx {
  font-size: 14px;
  font-weight: 600;
  color: #364e69;
}

.MileageAnalysisTab_bus_vehicleInfo__foHLu {
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
}

/* Selected Indicator */
.MileageAnalysisTab_bus_selectedIndicator__StUiV {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.MileageAnalysisTab_bus_checkmark__bKMHZ {
  color: white;
  font-size: 12px;
  font-weight: bold;
}

/* Add Button Container */
.MileageAnalysisTab_bus_addButtonContainer__8xkmj {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 15px;
}

.MileageAnalysisTab_bus_sectionTitle__sYjoz {
  color: #364e69;
  font-size: 14px;
}

/* Data card container styling */
.MileageAnalysisTab_bus_dataCard__h0Z8g {
  background-color: #e9ecef;
  border-radius: 4px;
  height: 50px;
}

/* Data label styling */
.MileageAnalysisTab_bus_dataLabel__KDd3- {
  font-size: 13px;
  color: #666;
}

/* Data value styling */
.MileageAnalysisTab_bus_dataValue__iL03G {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

/* Header text styling */
.MileageAnalysisTab_bus_headerText__grzSV {
  color: #364e69;
  font-size: 14px;
}

/* Label container styling */
.MileageAnalysisTab_bus_labelContainer__xlJmp {
  height: 40px;
}

/* Label text styling */
.MileageAnalysisTab_bus_labelText__T9XOO {
  font-size: 25px;
  color: #333;
  font-weight: 500;
}

/* Value container styling - shared for all value cells */
.MileageAnalysisTab_bus_valueContainer__QCfaf {
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
}

/* Value text styling - shared for all value text */
.MileageAnalysisTab_bus_valueText__SsDtZ {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

/* Main container background */
.MileageAnalysisTab_bus_containerBackground__XXlLG {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* Section Title */
.MileageAnalysisTab_bus_sectionTitle__sYjoz {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 14px;
}

/* Main Container */
.MileageAnalysisTab_bus_mainContainer__0bUV7 {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* Row Components */
.MileageAnalysisTab_bus_rowLabelContainer__MAtri {
  padding: 8px;
  display: flex;
  align-items: center;
  height: 40px;
}

.MileageAnalysisTab_bus_rowLabel__WvbZe {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.MileageAnalysisTab_bus_infoIcon__ybn0h {
  cursor: pointer;
}

.MileageAnalysisTab_bus_rowValueContainer__lG2QM {
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
  cursor: default;
}

.MileageAnalysisTab_bus_clickableRow__45m64 {
  cursor: pointer;
}

.MileageAnalysisTab_bus_rowValue__5pwYa {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.MileageAnalysisTab_bus_clickableValue__Fxedb {
  color: #358696;
}

/* Chart Container */
.MileageAnalysisTab_bus_chartContainer__7o\\+75 {
  margin-top: 12px;
}

/* Summary Cards */
.MileageAnalysisTab_bus_summaryCard__8rKJe {
  padding: 12px;
  border-radius: 4px;
  background-color: #e8f0fe;
}

.MileageAnalysisTab_bus_summaryCardLabel__BFQj7 {
  font-size: 11px;
  color: #5f6368;
  margin-bottom: 8px;
}

.MileageAnalysisTab_bus_currentValueText__cvF0C {
  font-size: 18px;
  font-weight: bold;
  color: #1a73e8;
  margin-right: 6px;
}

.MileageAnalysisTab_bus_bestValueText__sXrbM {
  font-size: 18px;
  font-weight: bold;
  color: #09a106;
  margin-right: 6px;
}

.MileageAnalysisTab_bus_positiveArrow__ViHQF {
  color: #34a853;
  font-size: 14px;
}

.MileageAnalysisTab_bus_negativeArrow__\\+1tw7 {
  color: #ea4335;
  font-size: 14px;
}

/* Chart Area */
.MileageAnalysisTab_bus_chartArea__q3ymK {
  position: relative;
  height: 350px;
  margin-top: 20px;
}

/* Y-axis */
.MileageAnalysisTab_bus_yAxisContainer__-Y0\\+K {
  position: absolute;
  left: 0;
  top: 20px;
  height: 260px;
  width: 40px;
}

.MileageAnalysisTab_bus_yAxisLabel__S7M0J {
  position: absolute;
  text-align: end;
  display: flex;
  align-items: center;
  justify-content: end;
  right: 5px;
  font-size: 11px;
  color: #5f6368;
  width: 30px;
  height: 20px;
}

/* Chart Grid */
.MileageAnalysisTab_bus_chartGrid__I-CSS {
  position: absolute;
  left: 45px;
  top: 20px;
  right: 0;
  height: 260px;
  border-left: 2px solid #e0e0e0;
  border-bottom: 2px solid #e0e0e0;
}

.MileageAnalysisTab_bus_gridLine__5VjVe {
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #f0f0f0;
}

.MileageAnalysisTab_bus_bottomGridLine__ivIXv {
  background-color: #e0e0e0;
}

/* Bars Container */
.MileageAnalysisTab_bus_barsContainer__vAphD {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: end;
  bottom: 0;
  height: 260px;
  gap: 10px;
  padding: 0 10px;
}

.MileageAnalysisTab_bus_barColumn__acuHZ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  flex: 1 1;
  height: 100%;
  position: relative;
}

.MileageAnalysisTab_bus_barValueLabel__jKcJt {
  text-align: center;
  position: absolute;
  font-size: 11px;
  font-weight: 600;
  color: #333;
  width: 100%;
}

.MileageAnalysisTab_bus_bar__7Mysi {
  width: 60%;
  max-width: 45px;
  border-radius: 3px 3px 0 0;
  transition: all 0.3s ease;
  align-self: center;
}

/* X-axis */
.MileageAnalysisTab_bus_xAxisContainer__MI\\+T\\+ {
  position: absolute;
  left: 45px;
  right: 0;
  top: 290px;
  display: flex;
  gap: 10px;
  padding: 0 10px;
}

.MileageAnalysisTab_bus_xAxisLabel__YxNdb {
  flex: 1 1;
  text-align: center;
  font-size: 10px;
  color: #5f6368;
  font-weight: 500;
  line-height: 1.2;
}

/* Chart Footer */
.MileageAnalysisTab_bus_chartFooterNote__njZV- {
  text-align: center;
  margin-top: 12px;
  font-size: 10px;
  color: #5f6368;
  font-style: italic;
}

/* Modal Styles */
.MileageAnalysisTab_bus_modalOverlay__QKlQn {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  animation: MileageAnalysisTab_bus_fadeIn__AgK84 0.3s ease-in-out;
}

.MileageAnalysisTab_bus_modalContent__b18VU {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 70%;
  max-width: 600px;
  min-width: 500px;
  max-height: 80vh;
  animation: MileageAnalysisTab_bus_slideIn__aY1jK 0.3s ease-out;
}

.MileageAnalysisTab_bus_tooltipModalContent__P9qnU {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 500px;
  animation: MileageAnalysisTab_bus_slideIn__aY1jK 0.3s ease-out;
}

.MileageAnalysisTab_bus_modalHeader__D97mu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #dee2e6;
  background-color: #f8f9fa;
}

.MileageAnalysisTab_bus_modalTitle__GbFkw {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 16px;
}

.MileageAnalysisTab_bus_modalBody__m0Khf {
  padding: 16px;
  overflow-y: auto;
  max-height: calc(80vh - 80px);
}

/* Tooltip Table Styles */
.MileageAnalysisTab_bus_tooltipTableContainer__L8Jx3 {
  padding: 12px;
}

.MileageAnalysisTab_bus_tooltipTable__gT\\+Po {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #dee2e6;
  margin-bottom: 0;
}

.MileageAnalysisTab_bus_tooltipTableHeader__qlMLi {
  background-color: #f8f9fa;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__H1fYG {
  text-align: center;
  font-weight: bold;
  font-size: 12px;
  color: #364e69;
  padding: 8px;
  border: 1px solid #dee2e6;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__H1fYG:nth-child(1) {
  width: 15%;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__H1fYG:nth-child(2) {
  width: 35%;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__H1fYG:nth-child(3) {
  width: 25%;
}

.MileageAnalysisTab_bus_tooltipTableHeaderCell__H1fYG:nth-child(4) {
  width: 25%;
}

.MileageAnalysisTab_bus_tooltipTableCell__9ETPt {
  text-align: center;
  font-size: 11px;
  padding: 8px;
  border: 1px solid #dee2e6;
}

.MileageAnalysisTab_bus_tooltipValueCell__VqNN8 {
  color: #4285f4;
}

/* Animations */
@keyframes MileageAnalysisTab_bus_fadeIn__AgK84 {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes MileageAnalysisTab_bus_slideIn__aY1jK {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Label container styling */
.MileageAnalysisTab_bus_labelContainer__xlJmp {
  padding: 8px;
  display: flex;
  align-items: center;
  float: left;
  height: 40px;
}

/* Data container styling */
.MileageAnalysisTab_bus_dataContainer__a6aYS {
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
}

/* Card container styling */
.MileageAnalysisTab_bus_cardContainer__59RVW {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* Card title styling */
.MileageAnalysisTab_bus_cardTitle__s4nRU {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 14px;
}

/* Label text styling */
.MileageAnalysisTab_bus_labelText__T9XOO {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

/* Base data text styling */
.MileageAnalysisTab_bus_dataText__hsBsy {
  font-size: 13px;
  font-weight: 600;
}

/* Normal text color */
.MileageAnalysisTab_bus_normalText__zL0xe {
  color: #333;
}

/* Percentage text color */
.MileageAnalysisTab_bus_percentageText__kmInH {
  color: #4285f4;
}

/* Container styles */
.MileageAnalysisTab_bus_cardContainer__59RVW {
  margin-bottom: 1rem;
}

.MileageAnalysisTab_bus_headerContainer__WND6b {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
}

.MileageAnalysisTab_bus_headerTitle__Vt9xA {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 14px;
}

.MileageAnalysisTab_bus_contentContainer__iC-I8 {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* Row styles */
.MileageAnalysisTab_bus_rowContainer__tewy- {
  margin-bottom: 0.5rem;
}

.MileageAnalysisTab_bus_labelColumn__4LkIj {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  height: 40px;
}

.MileageAnalysisTab_bus_labelColumnWithToggle__0RgLJ {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 40px;
}

.MileageAnalysisTab_bus_labelText__T9XOO {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.MileageAnalysisTab_bus_labelTextWithToggle__4wXBQ {
  font-size: 13px;
  color: #333;
  font-weight: 500;
  margin-bottom: 4px;
  text-align: left;
}

.MileageAnalysisTab_bus_dataColumn__JnnXk {
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
}

.MileageAnalysisTab_bus_dataText__hsBsy {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

/* Toggle button styles */
.MileageAnalysisTab_bus_toggleContainer__AUsIT {
  margin-top: 4px;
}

.MileageAnalysisTab_bus_toggleButton__HeKE7 {
  display: flex;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 15px;
  overflow: hidden;
  width: 90px;
  /* Increased to fit text */
  height: 24px;
  font-size: 10px;
  /* Smaller text */
  align-items: center;
  /* Vertically center text */
  justify-content: center;
  /* Horizontally center text */
  white-space: nowrap;
  /* Prevents wrapping */
}

.MileageAnalysisTab_bus_toggleOption__e78n0 {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.MileageAnalysisTab_bus_toggleOptionActive__g1HoC {
  background-color: #83a4cf;
  color: white;
}

.MileageAnalysisTab_bus_toggleOptionInactive__vUfFj {
  background-color: transparent;
  color: #666;
}

/* Header text styling */
.MileageAnalysisTab_bus_headerText__grzSV {
  color: #364e69;
  font-size: 14px;
}

/* Content container styling */
.MileageAnalysisTab_bus_contentContainer__iC-I8 {
  background-color: #f8f9fa;
  border-radius: 4px;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Success icon styling */
.MileageAnalysisTab_bus_successIcon__Znzs9 {
  font-size: 24px;
  color: #28a745;
}

/* Message text styling */
.MileageAnalysisTab_bus_messageText__7keuS {
  font-size: 14px;
  font-style: italic;
}

/* Vehicle Parameters Card Styles */
.MileageAnalysisTab_bus_cardContainer__59RVW {
  margin-bottom: 1.5rem;
}

.MileageAnalysisTab_bus_headerContainer__WND6b {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.MileageAnalysisTab_bus_headerTitle__Vt9xA {
  margin-bottom: 0;
  font-weight: bold;
  color: #364e69;
  font-size: 14px;
}

.MileageAnalysisTab_bus_parametersContainer__xD3Zc {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

.MileageAnalysisTab_bus_rowContainer__tewy- {
  margin-bottom: 0.5rem;
}

.MileageAnalysisTab_bus_labelCell__oDK98 {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  height: 40px;
}

.MileageAnalysisTab_bus_labelText__T9XOO {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.MileageAnalysisTab_bus_dataCell__jr2e\\+ {
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e9ecef;
  border-radius: 4px;
  height: 40px;
}

.MileageAnalysisTab_bus_dataText__hsBsy {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.MileageAnalysisTab_bus_placeholderContainer__01s3q {
  padding: 0.75rem;
  text-align: center;
  background-color: white;
  border-radius: 4px;
  margin-top: 10px;
  border: 1px dashed #dee2e6;
}

.MileageAnalysisTab_bus_placeholderText__BL8ck {
  margin-bottom: 0;
  color: #6c757d;
  font-size: 12px;
  font-style: italic;
}

/* Insights Card Styles */
.MileageAnalysisTab_bus_insightsCard__emMNV {
  background-color: white;
  border: 1px solid #e9ecef;
}

.MileageAnalysisTab_bus_insightsHeader__aPrdF {
  color: #364e69;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
}

.MileageAnalysisTab_bus_insightsList__jzvUg {
  padding-left: 20px;
  text-align: left;
}

.MileageAnalysisTab_bus_insightItem__U8O6J {
  color: #6c757d;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

/* Header and text colors */
.MileageAnalysisTab_bus_headerText__grzSV {
  color: #2c3e50;
}

.MileageAnalysisTab_bus_mutedText__XAsbL {
  color: #6c757d;
}

.MileageAnalysisTab_bus_brandColor__67rTq {
  color: #83a4cf;
}

/* Toggle buttons */
.MileageAnalysisTab_bus_toggleButton__HeKE7 {
  border-radius: 15px 0 0 15px;
  font-size: 0.9rem;
}

.MileageAnalysisTab_bus_toggleButtonRight__JU31q {
  border-radius: 0 15px 15px 0;
  font-size: 10px;
  /* Match the smaller size used in .toggleButton */
  display: flex;
  /* For centering content */
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.MileageAnalysisTab_bus_activeToggle__iv9BR {
  background-color: #83a4cf;
}

.MileageAnalysisTab_bus_inactiveToggle__iYqgM {
  background-color: transparent;
}

/* Description section */
.MileageAnalysisTab_bus_descriptionSection__EjJ9w {
  background-color: #f8f9fa;
}

/* Chart container */
.MileageAnalysisTab_bus_chartContainer__7o\\+75 {
  height: 400px;
  overflow-x: auto;
}

.MileageAnalysisTab_bus_chartSvg__pzVfs {
  min-width: 800px;
}

/* Text sizes */
.MileageAnalysisTab_bus_valueText__SsDtZ {
  font-size: 12px;
}

.MileageAnalysisTab_bus_labelText__T9XOO {
  font-size: 13px;
  color: #333;
  font-weight: 500;
}

.MileageAnalysisTab_bus_totalText__qnAY9 {
  font-size: 14px;
}

.MileageAnalysisTab_bus_actionButton__2QBQK {
  background-color: transparent;
  /* or your default bg */
  transition: background-color 0.2s;
}

.MileageAnalysisTab_bus_actionButton__2QBQK:hover {
  background-color: #83a4cf !important;
}

.MileageAnalysisTab_bus_infoBand__GE3kI {
  background-color: #358696;
  border-radius: 6px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: opacity 0.2s ease;
  width: fit-content;
  max-width: 100%;
}

.MileageAnalysisTab_bus_infoBand__GE3kI:hover {
  opacity: 0.9;
}

.MileageAnalysisTab_bus_infoBandText__peP1W {
  color: white;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
}

.MileageAnalysisTab_bus_infoBandIcon__VITbT {
  color: white;
  cursor: pointer;
  margin-left: 6px;
  flex-shrink: 0;
}

.MileageAnalysisTab_bus_infoBandIcon__VITbT:hover {
  opacity: 0.8;
}

.MileageAnalysisTab_bus_chartContainer__7o\\+75 {
  position: relative;
  padding-left: 40px;
  /* Increase as needed */
}

.MileageAnalysisTab_bus_doubleHeightCell__9SFS7 {
  min-height: 60px;
  /* Adjust height as needed */
  display: flex;
  align-items: center;
}

.MileageAnalysisTab_bus_tallRowValueContainer__Mxe0c {
  min-height: 60px;
  /* Height to match label + band combined */
  display: flex;
  align-items: center;
  justify-content: center;
}

.MileageAnalysisTab_bus_rowValueContainer__lG2QM {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 3px;
  /* Your existing styles */
}

/* Updated rowLabelContainer to contain both text and info band */
.MileageAnalysisTab_bus_rowLabelContainer__MAtri {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  padding: 8px 0;
  /* Vertical padding for the container */
}

.MileageAnalysisTab_bus_rowLabel__WvbZe {
  margin-bottom: 2px;
  /* Small gap between main text and info band */
}

/* Info band positioned directly under the main text */
.MileageAnalysisTab_bus_infoBand__GE3kI {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 0;
  padding-left: 0;
  /* Align with the main text */
}

.MileageAnalysisTab_bus_infoBandText__peP1W {
  font-size: 11px;
  color: white;
  /* Changed to white */
  line-height: 1.2;
  padding: 4px 12px;
  /* Increased padding for bigger width */
  border-radius: 15px;
  /* Rounded corners */
  text-align: center;
  /* Center aligned text */
  min-width: 80px;
  /* Minimum width for consistency */
  display: inline-block;
  /* Allows width and text-align to work properly */
}

.MileageAnalysisTab_bus_infoBandIcon__VITbT {
  cursor: pointer;
  color: white;
}

/* Remove the separate info band row styling since we're not using it anymore */
.MileageAnalysisTab_bus_infoBandRow__kXjAs {
  display: none;
}


.MileageAnalysisTab_bus_spanHeight__7THjl {
  height: 60px
}

.MileageAnalysisTab_bus_disabledTab__mlafc {
  /* background-color: #f0f0f0 !important; */
  /* Fainter background */
  color: #999 !important;
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.8;
}

.MileageAnalysisTab_bus_disabledTab__mlafc:hover {
  cursor: not-allowed;
  background-color: #e4e4e4;
}

.MileageAnalysisTab_bus_custom_popover_width__cJVeP {
  width: 420px !important;
  max-width: none !important;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/MileageAnalysisTab_ace/MileageAnalysisTab_bus.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;EACb,gEAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8DAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;EAChB,8DAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,aAAa;AACf;;;AAGA;EACE;AACF;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B","sourcesContent":["/* Header Styles */\n.analysis_header {\n  color: #364e69;\n}\n\n.selected_header {\n  color: #364e69;\n}\n\n/* Download Button */\n.download_button {\n  color: #83a4cf;\n  background-color: transparent;\n  border: none;\n}\n\n/* Tabs Container */\n.tabs_container {\n  background-color: #e9ecef;\n}\n\n.tabs_wrapper {\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.tabs_wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n/* Tab Item */\n.tab_item {\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  padding-bottom: 8px;\n}\n\n.tab_item_active {\n  color: #358696;\n  border-bottom: 2px solid #358696;\n}\n\n.tab_item_inactive {\n  color: #6c757d;\n}\n\n/* Progress Bar */\n.progress_container {\n  height: 8px;\n  background-color: #ced4da;\n}\n\n.progress_bar {\n  background-color: #6c757d;\n  transition: width 0.3s ease;\n}\n\n/* Benchmark Tabs */\n.benchmark_tab {\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.benchmark_tab_active {\n  color: #358696;\n  border-bottom: 2px solid #358696;\n}\n\n.benchmark_tab_inactive {\n  color: #6c757d;\n}\n\n/* Chart Icon */\n.chart_icon {\n  color: #364e69;\n}\n\n/* Filter Summary */\n.filter_summary {\n  color: #6c757d;\n}\n\n/* Section Container */\n.section_container {\n  background-color: white;\n  border: 1px solid #e9ecef;\n  min-height: 300px;\n  scroll-margin-top: 20px;\n}\n\n/* Section Header */\n.section_header {\n  padding-bottom: 8px;\n  transition: all 0.2s ease;\n}\n\n.section_header_active {\n  color: #83a4cf;\n  border-bottom: 2px solid #83a4cf;\n}\n\n.section_header_inactive {\n  color: #364e69;\n  border-bottom: 2px solid #e9ecef;\n}\n\n/* Special Sections */\n.mileage_insights_container {\n  background-color: white;\n  border: 1px solid #e9ecef;\n  scroll-margin-top: 20px;\n}\n\n.waterfall_chart_container {\n  background-color: white;\n  border: 1px solid #e9ecef;\n  scroll-margin-top: 20px;\n}\n\n/* Content Placeholder */\n.content_placeholder {\n  color: #6c757d;\n}\n\n/* Vehicle Container */\n.vehicleContainer {\n  height: 120px;\n  gap: 15px;\n  background-color: white;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n/* Vehicle Details Section */\n.vehicleDetailsSection {\n  background-color: white;\n  border-radius: 4px;\n  height: 100%;\n  min-width: 150px;\n}\n\n.vehicleDetailsTitle {\n  color: #364e69;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* Add Vehicle Slot Styles */\n.addVehicleSlot {\n  background-color: #77c4d3;\n  border-radius: 4px;\n  height: 100%;\n  min-width: 150px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.addVehicleSlot:hover {\n  background-color: #85ccdb;\n}\n\n/* Selected Vehicle Slot */\n.selectedVehicleSlot {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  height: 100%;\n  min-width: 150px;\n  cursor: pointer;\n}\n\n/* Add Vehicle Content */\n.addVehicleContent {\n  color: #364e69;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.addVehicleIcon {\n  width: 20px;\n  height: 20px;\n  background-color: #358696;\n  border-radius: 50%;\n}\n\n/* Selected Vehicle Text */\n.selectedVehicleText {\n  font-size: 12px;\n  color: #364e69;\n  font-weight: 600;\n  text-align: center;\n  word-break: break-word;\n}\n\n/* Best Day Section */\n.bestDaySection {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  height: 100%;\n}\n\n.bestDayText {\n  font-style: italic;\n  font-size: 12px;\n}\n\n/* Selected Vehicle Display */\n.selectedVehicleDisplay {\n  background-color: rgba(66, 133, 244, 0.1);\n}\n\n.selectedVehicleLabel {\n  font-size: 12px;\n  color: #333;\n}\n\n.clearButton {\n  background-color: transparent;\n  border: none;\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n}\n\n.modalContainer {\n  width: 500px;\n  max-height: 600px;\n  overflow: hidden;\n}\n\n.modalTitle {\n  color: #364e69;\n  font-weight: 600;\n}\n\n.closeButton {\n  background-color: transparent;\n  border: none;\n}\n\n/* Search Input */\n.searchIcon {\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n}\n\n.searchInput {\n  padding-left: 40px;\n  font-size: 14px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n}\n\n/* Vehicle List */\n.vehicleList {\n  max-height: 400px;\n  overflow-y: auto;\n  min-height: 300px;\n}\n\n/* Empty State */\n.emptyStateTitle {\n  font-size: 16px;\n}\n\n.emptyStateSubtitle {\n  font-size: 14px;\n}\n\n/* Vehicle Item Styles */\n.vehicleItem {\n  cursor: pointer;\n  transition: all 0.2s;\n  border-width: 1px;\n}\n\n.vehicleItem:hover {\n  background-color: #f8f9fa;\n}\n\n.vehicleItemSelected {\n  border-width: 2px;\n}\n\n.vehicleName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #364e69;\n}\n\n.vehicleInfo {\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n}\n\n/* Selected Indicator */\n.selectedIndicator {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #007bff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.checkmark {\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n/* Add Button Container */\n.addButtonContainer {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 15px;\n}\n\n.sectionTitle {\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Data card container styling */\n.dataCard {\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 50px;\n}\n\n/* Data label styling */\n.dataLabel {\n  font-size: 13px;\n  color: #666;\n}\n\n/* Data value styling */\n.dataValue {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Header text styling */\n.headerText {\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Label container styling */\n.labelContainer {\n  height: 40px;\n}\n\n/* Label text styling */\n.labelText {\n  font-size: 25px;\n  color: #333;\n  font-weight: 500;\n}\n\n/* Value container styling - shared for all value cells */\n.valueContainer {\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n}\n\n/* Value text styling - shared for all value text */\n.valueText {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Main container background */\n.containerBackground {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n/* Section Title */\n.sectionTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Main Container */\n.mainContainer {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n/* Row Components */\n.rowLabelContainer {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.rowLabel {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n.infoIcon {\n  cursor: pointer;\n}\n\n.rowValueContainer {\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n  cursor: default;\n}\n\n.clickableRow {\n  cursor: pointer;\n}\n\n.rowValue {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.clickableValue {\n  color: #358696;\n}\n\n/* Chart Container */\n.chartContainer {\n  margin-top: 12px;\n}\n\n/* Summary Cards */\n.summaryCard {\n  padding: 12px;\n  border-radius: 4px;\n  background-color: #e8f0fe;\n}\n\n.summaryCardLabel {\n  font-size: 11px;\n  color: #5f6368;\n  margin-bottom: 8px;\n}\n\n.currentValueText {\n  font-size: 18px;\n  font-weight: bold;\n  color: #1a73e8;\n  margin-right: 6px;\n}\n\n.bestValueText {\n  font-size: 18px;\n  font-weight: bold;\n  color: #09a106;\n  margin-right: 6px;\n}\n\n.positiveArrow {\n  color: #34a853;\n  font-size: 14px;\n}\n\n.negativeArrow {\n  color: #ea4335;\n  font-size: 14px;\n}\n\n/* Chart Area */\n.chartArea {\n  position: relative;\n  height: 350px;\n  margin-top: 20px;\n}\n\n/* Y-axis */\n.yAxisContainer {\n  position: absolute;\n  left: 0;\n  top: 20px;\n  height: 260px;\n  width: 40px;\n}\n\n.yAxisLabel {\n  position: absolute;\n  text-align: end;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  right: 5px;\n  font-size: 11px;\n  color: #5f6368;\n  width: 30px;\n  height: 20px;\n}\n\n/* Chart Grid */\n.chartGrid {\n  position: absolute;\n  left: 45px;\n  top: 20px;\n  right: 0;\n  height: 260px;\n  border-left: 2px solid #e0e0e0;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.gridLine {\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  background-color: #f0f0f0;\n}\n\n.bottomGridLine {\n  background-color: #e0e0e0;\n}\n\n/* Bars Container */\n.barsContainer {\n  position: absolute;\n  width: 100%;\n  display: flex;\n  align-items: end;\n  bottom: 0;\n  height: 260px;\n  gap: 10px;\n  padding: 0 10px;\n}\n\n.barColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: end;\n  flex: 1;\n  height: 100%;\n  position: relative;\n}\n\n.barValueLabel {\n  text-align: center;\n  position: absolute;\n  font-size: 11px;\n  font-weight: 600;\n  color: #333;\n  width: 100%;\n}\n\n.bar {\n  width: 60%;\n  max-width: 45px;\n  border-radius: 3px 3px 0 0;\n  transition: all 0.3s ease;\n  align-self: center;\n}\n\n/* X-axis */\n.xAxisContainer {\n  position: absolute;\n  left: 45px;\n  right: 0;\n  top: 290px;\n  display: flex;\n  gap: 10px;\n  padding: 0 10px;\n}\n\n.xAxisLabel {\n  flex: 1;\n  text-align: center;\n  font-size: 10px;\n  color: #5f6368;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n/* Chart Footer */\n.chartFooterNote {\n  text-align: center;\n  margin-top: 12px;\n  font-size: 10px;\n  color: #5f6368;\n  font-style: italic;\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1050;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.modalContent {\n  background-color: white;\n  border-radius: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 70%;\n  max-width: 600px;\n  min-width: 500px;\n  max-height: 80vh;\n  animation: slideIn 0.3s ease-out;\n}\n\n.tooltipModalContent {\n  background-color: white;\n  border-radius: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 500px;\n  animation: slideIn 0.3s ease-out;\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  border-bottom: 1px solid #dee2e6;\n  background-color: #f8f9fa;\n}\n\n.modalTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 16px;\n}\n\n.modalBody {\n  padding: 16px;\n  overflow-y: auto;\n  max-height: calc(80vh - 80px);\n}\n\n/* Tooltip Table Styles */\n.tooltipTableContainer {\n  padding: 12px;\n}\n\n.tooltipTable {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #dee2e6;\n  margin-bottom: 0;\n}\n\n.tooltipTableHeader {\n  background-color: #f8f9fa;\n}\n\n.tooltipTableHeaderCell {\n  text-align: center;\n  font-weight: bold;\n  font-size: 12px;\n  color: #364e69;\n  padding: 8px;\n  border: 1px solid #dee2e6;\n}\n\n.tooltipTableHeaderCell:nth-child(1) {\n  width: 15%;\n}\n\n.tooltipTableHeaderCell:nth-child(2) {\n  width: 35%;\n}\n\n.tooltipTableHeaderCell:nth-child(3) {\n  width: 25%;\n}\n\n.tooltipTableHeaderCell:nth-child(4) {\n  width: 25%;\n}\n\n.tooltipTableCell {\n  text-align: center;\n  font-size: 11px;\n  padding: 8px;\n  border: 1px solid #dee2e6;\n}\n\n.tooltipValueCell {\n  color: #4285f4;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-50px) scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Label container styling */\n.labelContainer {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  float: left;\n  height: 40px;\n}\n\n/* Data container styling */\n.dataContainer {\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n}\n\n/* Card container styling */\n.cardContainer {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n/* Card title styling */\n.cardTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Label text styling */\n.labelText {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n/* Base data text styling */\n.dataText {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n/* Normal text color */\n.normalText {\n  color: #333;\n}\n\n/* Percentage text color */\n.percentageText {\n  color: #4285f4;\n}\n\n/* Container styles */\n.cardContainer {\n  margin-bottom: 1rem;\n}\n\n.headerContainer {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.headerTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 14px;\n}\n\n.contentContainer {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n/* Row styles */\n.rowContainer {\n  margin-bottom: 0.5rem;\n}\n\n.labelColumn {\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.labelColumnWithToggle {\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: 40px;\n}\n\n.labelText {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n.labelTextWithToggle {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n  margin-bottom: 4px;\n  text-align: left;\n}\n\n.dataColumn {\n  padding: 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n}\n\n.dataText {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Toggle button styles */\n.toggleContainer {\n  margin-top: 4px;\n}\n\n.toggleButton {\n  display: flex;\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 15px;\n  overflow: hidden;\n  width: 90px;\n  /* Increased to fit text */\n  height: 24px;\n  font-size: 10px;\n  /* Smaller text */\n  align-items: center;\n  /* Vertically center text */\n  justify-content: center;\n  /* Horizontally center text */\n  white-space: nowrap;\n  /* Prevents wrapping */\n}\n\n.toggleOption {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.toggleOptionActive {\n  background-color: #83a4cf;\n  color: white;\n}\n\n.toggleOptionInactive {\n  background-color: transparent;\n  color: #666;\n}\n\n/* Header text styling */\n.headerText {\n  color: #364e69;\n  font-size: 14px;\n}\n\n/* Content container styling */\n.contentContainer {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  min-height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Success icon styling */\n.successIcon {\n  font-size: 24px;\n  color: #28a745;\n}\n\n/* Message text styling */\n.messageText {\n  font-size: 14px;\n  font-style: italic;\n}\n\n/* Vehicle Parameters Card Styles */\n.cardContainer {\n  margin-bottom: 1.5rem;\n}\n\n.headerContainer {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.headerTitle {\n  margin-bottom: 0;\n  font-weight: bold;\n  color: #364e69;\n  font-size: 14px;\n}\n\n.parametersContainer {\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n.rowContainer {\n  margin-bottom: 0.5rem;\n}\n\n.labelCell {\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.labelText {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n.dataCell {\n  padding: 0.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  height: 40px;\n}\n\n.dataText {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.placeholderContainer {\n  padding: 0.75rem;\n  text-align: center;\n  background-color: white;\n  border-radius: 4px;\n  margin-top: 10px;\n  border: 1px dashed #dee2e6;\n}\n\n.placeholderText {\n  margin-bottom: 0;\n  color: #6c757d;\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* Insights Card Styles */\n.insightsCard {\n  background-color: white;\n  border: 1px solid #e9ecef;\n}\n\n.insightsHeader {\n  color: #364e69;\n  border-bottom: 2px solid #e9ecef;\n  padding-bottom: 8px;\n}\n\n.insightsList {\n  padding-left: 20px;\n  text-align: left;\n}\n\n.insightItem {\n  color: #6c757d;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n}\n\n/* Header and text colors */\n.headerText {\n  color: #2c3e50;\n}\n\n.mutedText {\n  color: #6c757d;\n}\n\n.brandColor {\n  color: #83a4cf;\n}\n\n/* Toggle buttons */\n.toggleButton {\n  border-radius: 15px 0 0 15px;\n  font-size: 0.9rem;\n}\n\n.toggleButtonRight {\n  border-radius: 0 15px 15px 0;\n  font-size: 10px;\n  /* Match the smaller size used in .toggleButton */\n  display: flex;\n  /* For centering content */\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.activeToggle {\n  background-color: #83a4cf;\n}\n\n.inactiveToggle {\n  background-color: transparent;\n}\n\n/* Description section */\n.descriptionSection {\n  background-color: #f8f9fa;\n}\n\n/* Chart container */\n.chartContainer {\n  height: 400px;\n  overflow-x: auto;\n}\n\n.chartSvg {\n  min-width: 800px;\n}\n\n/* Text sizes */\n.valueText {\n  font-size: 12px;\n}\n\n.labelText {\n  font-size: 13px;\n  color: #333;\n  font-weight: 500;\n}\n\n.totalText {\n  font-size: 14px;\n}\n\n.actionButton {\n  background-color: transparent;\n  /* or your default bg */\n  transition: background-color 0.2s;\n}\n\n.actionButton:hover {\n  background-color: #83a4cf !important;\n}\n\n.infoBand {\n  background-color: #358696;\n  border-radius: 6px;\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  width: fit-content;\n  max-width: 100%;\n}\n\n.infoBand:hover {\n  opacity: 0.9;\n}\n\n.infoBandText {\n  color: white;\n  font-size: 10px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.infoBandIcon {\n  color: white;\n  cursor: pointer;\n  margin-left: 6px;\n  flex-shrink: 0;\n}\n\n.infoBandIcon:hover {\n  opacity: 0.8;\n}\n\n.chartContainer {\n  position: relative;\n  padding-left: 40px;\n  /* Increase as needed */\n}\n\n.doubleHeightCell {\n  min-height: 60px;\n  /* Adjust height as needed */\n  display: flex;\n  align-items: center;\n}\n\n.tallRowValueContainer {\n  min-height: 60px;\n  /* Height to match label + band combined */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rowValueContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1px 3px;\n  /* Your existing styles */\n}\n\n/* Updated rowLabelContainer to contain both text and info band */\n.rowLabelContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  height: 100%;\n  padding: 8px 0;\n  /* Vertical padding for the container */\n}\n\n.rowLabel {\n  margin-bottom: 2px;\n  /* Small gap between main text and info band */\n}\n\n/* Info band positioned directly under the main text */\n.infoBand {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 0;\n  padding-left: 0;\n  /* Align with the main text */\n}\n\n.infoBandText {\n  font-size: 11px;\n  color: white;\n  /* Changed to white */\n  line-height: 1.2;\n  padding: 4px 12px;\n  /* Increased padding for bigger width */\n  border-radius: 15px;\n  /* Rounded corners */\n  text-align: center;\n  /* Center aligned text */\n  min-width: 80px;\n  /* Minimum width for consistency */\n  display: inline-block;\n  /* Allows width and text-align to work properly */\n}\n\n.infoBandIcon {\n  cursor: pointer;\n  color: white;\n}\n\n/* Remove the separate info band row styling since we're not using it anymore */\n.infoBandRow {\n  display: none;\n}\n\n\n.spanHeight {\n  height: 60px\n}\n\n.disabledTab {\n  /* background-color: #f0f0f0 !important; */\n  /* Fainter background */\n  color: #999 !important;\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.disabledTab:hover {\n  cursor: not-allowed;\n  background-color: #e4e4e4;\n}\n\n.custom_popover_width {\n  width: 420px !important;\n  max-width: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"analysis_header": `MileageAnalysisTab_bus_analysis_header__Wx4n0`,
	"selected_header": `MileageAnalysisTab_bus_selected_header__3w-B-`,
	"download_button": `MileageAnalysisTab_bus_download_button__ASssO`,
	"tabs_container": `MileageAnalysisTab_bus_tabs_container__vI1ID`,
	"tabs_wrapper": `MileageAnalysisTab_bus_tabs_wrapper__z5147`,
	"tab_item": `MileageAnalysisTab_bus_tab_item__+ykSg`,
	"tab_item_active": `MileageAnalysisTab_bus_tab_item_active__bUMHb`,
	"tab_item_inactive": `MileageAnalysisTab_bus_tab_item_inactive__+p8y2`,
	"progress_container": `MileageAnalysisTab_bus_progress_container__i1JeK`,
	"progress_bar": `MileageAnalysisTab_bus_progress_bar__F5HH-`,
	"benchmark_tab": `MileageAnalysisTab_bus_benchmark_tab__45lfm`,
	"benchmark_tab_active": `MileageAnalysisTab_bus_benchmark_tab_active__8lKW-`,
	"benchmark_tab_inactive": `MileageAnalysisTab_bus_benchmark_tab_inactive__4UTIH`,
	"chart_icon": `MileageAnalysisTab_bus_chart_icon__3CSV1`,
	"filter_summary": `MileageAnalysisTab_bus_filter_summary__Pm8zC`,
	"section_container": `MileageAnalysisTab_bus_section_container__iy8Tq`,
	"section_header": `MileageAnalysisTab_bus_section_header__ltXgW`,
	"section_header_active": `MileageAnalysisTab_bus_section_header_active__-qe98`,
	"section_header_inactive": `MileageAnalysisTab_bus_section_header_inactive__8-RNc`,
	"mileage_insights_container": `MileageAnalysisTab_bus_mileage_insights_container__qFA6C`,
	"waterfall_chart_container": `MileageAnalysisTab_bus_waterfall_chart_container__uIMY9`,
	"content_placeholder": `MileageAnalysisTab_bus_content_placeholder__yVg8d`,
	"vehicleContainer": `MileageAnalysisTab_bus_vehicleContainer__U3THW`,
	"vehicleDetailsSection": `MileageAnalysisTab_bus_vehicleDetailsSection__BYBBt`,
	"vehicleDetailsTitle": `MileageAnalysisTab_bus_vehicleDetailsTitle__Y9lX+`,
	"addVehicleSlot": `MileageAnalysisTab_bus_addVehicleSlot__txTu7`,
	"selectedVehicleSlot": `MileageAnalysisTab_bus_selectedVehicleSlot__tnGSl`,
	"addVehicleContent": `MileageAnalysisTab_bus_addVehicleContent__Fp9Hi`,
	"addVehicleIcon": `MileageAnalysisTab_bus_addVehicleIcon__aV3HP`,
	"selectedVehicleText": `MileageAnalysisTab_bus_selectedVehicleText__0LSY7`,
	"bestDaySection": `MileageAnalysisTab_bus_bestDaySection__PQ1hL`,
	"bestDayText": `MileageAnalysisTab_bus_bestDayText__UuxLv`,
	"selectedVehicleDisplay": `MileageAnalysisTab_bus_selectedVehicleDisplay__Z8IE8`,
	"selectedVehicleLabel": `MileageAnalysisTab_bus_selectedVehicleLabel__JYXhs`,
	"clearButton": `MileageAnalysisTab_bus_clearButton__Q75EL`,
	"modalOverlay": `MileageAnalysisTab_bus_modalOverlay__QKlQn`,
	"modalContainer": `MileageAnalysisTab_bus_modalContainer__9oGQz`,
	"modalTitle": `MileageAnalysisTab_bus_modalTitle__GbFkw`,
	"closeButton": `MileageAnalysisTab_bus_closeButton__zpjTr`,
	"searchIcon": `MileageAnalysisTab_bus_searchIcon__1Eg+E`,
	"searchInput": `MileageAnalysisTab_bus_searchInput__1aeru`,
	"vehicleList": `MileageAnalysisTab_bus_vehicleList__fVRsV`,
	"emptyStateTitle": `MileageAnalysisTab_bus_emptyStateTitle__SG-0s`,
	"emptyStateSubtitle": `MileageAnalysisTab_bus_emptyStateSubtitle__eoF3O`,
	"vehicleItem": `MileageAnalysisTab_bus_vehicleItem__10j44`,
	"vehicleItemSelected": `MileageAnalysisTab_bus_vehicleItemSelected__9+R6C`,
	"vehicleName": `MileageAnalysisTab_bus_vehicleName__-kvbx`,
	"vehicleInfo": `MileageAnalysisTab_bus_vehicleInfo__foHLu`,
	"selectedIndicator": `MileageAnalysisTab_bus_selectedIndicator__StUiV`,
	"checkmark": `MileageAnalysisTab_bus_checkmark__bKMHZ`,
	"addButtonContainer": `MileageAnalysisTab_bus_addButtonContainer__8xkmj`,
	"sectionTitle": `MileageAnalysisTab_bus_sectionTitle__sYjoz`,
	"dataCard": `MileageAnalysisTab_bus_dataCard__h0Z8g`,
	"dataLabel": `MileageAnalysisTab_bus_dataLabel__KDd3-`,
	"dataValue": `MileageAnalysisTab_bus_dataValue__iL03G`,
	"headerText": `MileageAnalysisTab_bus_headerText__grzSV`,
	"labelContainer": `MileageAnalysisTab_bus_labelContainer__xlJmp`,
	"labelText": `MileageAnalysisTab_bus_labelText__T9XOO`,
	"valueContainer": `MileageAnalysisTab_bus_valueContainer__QCfaf`,
	"valueText": `MileageAnalysisTab_bus_valueText__SsDtZ`,
	"containerBackground": `MileageAnalysisTab_bus_containerBackground__XXlLG`,
	"mainContainer": `MileageAnalysisTab_bus_mainContainer__0bUV7`,
	"rowLabelContainer": `MileageAnalysisTab_bus_rowLabelContainer__MAtri`,
	"rowLabel": `MileageAnalysisTab_bus_rowLabel__WvbZe`,
	"infoIcon": `MileageAnalysisTab_bus_infoIcon__ybn0h`,
	"rowValueContainer": `MileageAnalysisTab_bus_rowValueContainer__lG2QM`,
	"clickableRow": `MileageAnalysisTab_bus_clickableRow__45m64`,
	"rowValue": `MileageAnalysisTab_bus_rowValue__5pwYa`,
	"clickableValue": `MileageAnalysisTab_bus_clickableValue__Fxedb`,
	"chartContainer": `MileageAnalysisTab_bus_chartContainer__7o+75`,
	"summaryCard": `MileageAnalysisTab_bus_summaryCard__8rKJe`,
	"summaryCardLabel": `MileageAnalysisTab_bus_summaryCardLabel__BFQj7`,
	"currentValueText": `MileageAnalysisTab_bus_currentValueText__cvF0C`,
	"bestValueText": `MileageAnalysisTab_bus_bestValueText__sXrbM`,
	"positiveArrow": `MileageAnalysisTab_bus_positiveArrow__ViHQF`,
	"negativeArrow": `MileageAnalysisTab_bus_negativeArrow__+1tw7`,
	"chartArea": `MileageAnalysisTab_bus_chartArea__q3ymK`,
	"yAxisContainer": `MileageAnalysisTab_bus_yAxisContainer__-Y0+K`,
	"yAxisLabel": `MileageAnalysisTab_bus_yAxisLabel__S7M0J`,
	"chartGrid": `MileageAnalysisTab_bus_chartGrid__I-CSS`,
	"gridLine": `MileageAnalysisTab_bus_gridLine__5VjVe`,
	"bottomGridLine": `MileageAnalysisTab_bus_bottomGridLine__ivIXv`,
	"barsContainer": `MileageAnalysisTab_bus_barsContainer__vAphD`,
	"barColumn": `MileageAnalysisTab_bus_barColumn__acuHZ`,
	"barValueLabel": `MileageAnalysisTab_bus_barValueLabel__jKcJt`,
	"bar": `MileageAnalysisTab_bus_bar__7Mysi`,
	"xAxisContainer": `MileageAnalysisTab_bus_xAxisContainer__MI+T+`,
	"xAxisLabel": `MileageAnalysisTab_bus_xAxisLabel__YxNdb`,
	"chartFooterNote": `MileageAnalysisTab_bus_chartFooterNote__njZV-`,
	"fadeIn": `MileageAnalysisTab_bus_fadeIn__AgK84`,
	"modalContent": `MileageAnalysisTab_bus_modalContent__b18VU`,
	"slideIn": `MileageAnalysisTab_bus_slideIn__aY1jK`,
	"tooltipModalContent": `MileageAnalysisTab_bus_tooltipModalContent__P9qnU`,
	"modalHeader": `MileageAnalysisTab_bus_modalHeader__D97mu`,
	"modalBody": `MileageAnalysisTab_bus_modalBody__m0Khf`,
	"tooltipTableContainer": `MileageAnalysisTab_bus_tooltipTableContainer__L8Jx3`,
	"tooltipTable": `MileageAnalysisTab_bus_tooltipTable__gT+Po`,
	"tooltipTableHeader": `MileageAnalysisTab_bus_tooltipTableHeader__qlMLi`,
	"tooltipTableHeaderCell": `MileageAnalysisTab_bus_tooltipTableHeaderCell__H1fYG`,
	"tooltipTableCell": `MileageAnalysisTab_bus_tooltipTableCell__9ETPt`,
	"tooltipValueCell": `MileageAnalysisTab_bus_tooltipValueCell__VqNN8`,
	"dataContainer": `MileageAnalysisTab_bus_dataContainer__a6aYS`,
	"cardContainer": `MileageAnalysisTab_bus_cardContainer__59RVW`,
	"cardTitle": `MileageAnalysisTab_bus_cardTitle__s4nRU`,
	"dataText": `MileageAnalysisTab_bus_dataText__hsBsy`,
	"normalText": `MileageAnalysisTab_bus_normalText__zL0xe`,
	"percentageText": `MileageAnalysisTab_bus_percentageText__kmInH`,
	"headerContainer": `MileageAnalysisTab_bus_headerContainer__WND6b`,
	"headerTitle": `MileageAnalysisTab_bus_headerTitle__Vt9xA`,
	"contentContainer": `MileageAnalysisTab_bus_contentContainer__iC-I8`,
	"rowContainer": `MileageAnalysisTab_bus_rowContainer__tewy-`,
	"labelColumn": `MileageAnalysisTab_bus_labelColumn__4LkIj`,
	"labelColumnWithToggle": `MileageAnalysisTab_bus_labelColumnWithToggle__0RgLJ`,
	"labelTextWithToggle": `MileageAnalysisTab_bus_labelTextWithToggle__4wXBQ`,
	"dataColumn": `MileageAnalysisTab_bus_dataColumn__JnnXk`,
	"toggleContainer": `MileageAnalysisTab_bus_toggleContainer__AUsIT`,
	"toggleButton": `MileageAnalysisTab_bus_toggleButton__HeKE7`,
	"toggleOption": `MileageAnalysisTab_bus_toggleOption__e78n0`,
	"toggleOptionActive": `MileageAnalysisTab_bus_toggleOptionActive__g1HoC`,
	"toggleOptionInactive": `MileageAnalysisTab_bus_toggleOptionInactive__vUfFj`,
	"successIcon": `MileageAnalysisTab_bus_successIcon__Znzs9`,
	"messageText": `MileageAnalysisTab_bus_messageText__7keuS`,
	"parametersContainer": `MileageAnalysisTab_bus_parametersContainer__xD3Zc`,
	"labelCell": `MileageAnalysisTab_bus_labelCell__oDK98`,
	"dataCell": `MileageAnalysisTab_bus_dataCell__jr2e+`,
	"placeholderContainer": `MileageAnalysisTab_bus_placeholderContainer__01s3q`,
	"placeholderText": `MileageAnalysisTab_bus_placeholderText__BL8ck`,
	"insightsCard": `MileageAnalysisTab_bus_insightsCard__emMNV`,
	"insightsHeader": `MileageAnalysisTab_bus_insightsHeader__aPrdF`,
	"insightsList": `MileageAnalysisTab_bus_insightsList__jzvUg`,
	"insightItem": `MileageAnalysisTab_bus_insightItem__U8O6J`,
	"mutedText": `MileageAnalysisTab_bus_mutedText__XAsbL`,
	"brandColor": `MileageAnalysisTab_bus_brandColor__67rTq`,
	"toggleButtonRight": `MileageAnalysisTab_bus_toggleButtonRight__JU31q`,
	"activeToggle": `MileageAnalysisTab_bus_activeToggle__iv9BR`,
	"inactiveToggle": `MileageAnalysisTab_bus_inactiveToggle__iYqgM`,
	"descriptionSection": `MileageAnalysisTab_bus_descriptionSection__EjJ9w`,
	"chartSvg": `MileageAnalysisTab_bus_chartSvg__pzVfs`,
	"totalText": `MileageAnalysisTab_bus_totalText__qnAY9`,
	"actionButton": `MileageAnalysisTab_bus_actionButton__2QBQK`,
	"infoBand": `MileageAnalysisTab_bus_infoBand__GE3kI`,
	"infoBandText": `MileageAnalysisTab_bus_infoBandText__peP1W`,
	"infoBandIcon": `MileageAnalysisTab_bus_infoBandIcon__VITbT`,
	"doubleHeightCell": `MileageAnalysisTab_bus_doubleHeightCell__9SFS7`,
	"tallRowValueContainer": `MileageAnalysisTab_bus_tallRowValueContainer__Mxe0c`,
	"infoBandRow": `MileageAnalysisTab_bus_infoBandRow__kXjAs`,
	"spanHeight": `MileageAnalysisTab_bus_spanHeight__7THjl`,
	"disabledTab": `MileageAnalysisTab_bus_disabledTab__mlafc`,
	"custom_popover_width": `MileageAnalysisTab_bus_custom_popover_width__cJVeP`
};
export default ___CSS_LOADER_EXPORT___;
